// extracted by mini-css-extract-plugin
module.exports = {"search":"PartnerCampaignDetailsTable_search__3Fjkt","table":"PartnerCampaignDetailsTable_table__1cOdm"};